import React from "react";

export default function ReviewAgentIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_13808_25325"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13808_25325)">
        <path
          d="M10.0831 13.4719C9.69626 13.4055 9.69626 12.8669 10.0831 12.8016C10.768 12.6858 11.4019 12.3744 11.904 11.9072C12.4061 11.44 12.7536 10.8381 12.9022 10.1782L12.9253 10.0733C13.0091 9.70169 13.5535 9.69848 13.6406 10.07L13.6693 10.191C13.8235 10.848 14.1741 11.446 14.677 11.9099C15.18 12.3738 15.8128 12.6829 16.4961 12.7984C16.8851 12.8637 16.8851 13.4066 16.4961 13.473C15.813 13.5887 15.1804 13.8979 14.6777 14.3618C14.1749 14.8257 13.8245 15.4236 13.6704 16.0804L13.6417 16.2003C13.5546 16.5708 13.0102 16.5687 12.9265 16.1971L12.9044 16.0943C12.7556 15.4341 12.4078 14.832 11.9053 14.3648C11.4028 13.8975 10.7684 13.5874 10.0831 13.4719Z"
          fill="#F9F9F9"
        />
        <path
          d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V7.98757C15.75 8.35339 15.3667 8.59744 15.0188 8.48438C14.5876 8.34425 14.25 7.96951 14.25 7.51615V4.7363C14.25 4.19158 13.8084 3.75 13.2637 3.75H3.75V14.25H7.47903C7.94219 14.25 8.32247 14.597 8.46563 15.0375C8.575 15.374 8.3399 15.75 7.98604 15.75H3.75ZM3.75 14.25V3.75V8.30625V8.25V14.25ZM5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H7.51616C7.96951 12.75 8.34425 12.4124 8.48438 11.9813C8.59892 11.6288 8.34644 11.25 7.97586 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12ZM5.25 9C5.25 9.41421 5.58579 9.75 6 9.75H9.43497C9.68555 9.75 9.92435 9.65167 10.1183 9.49306C10.4402 9.2299 10.7893 9.00304 11.1656 8.8125C11.6519 8.5663 12.1714 8.3989 12.7244 8.3103C12.7391 8.30794 12.75 8.29524 12.75 8.2803C12.75 8.26357 12.7364 8.25 12.7197 8.25H6C5.58579 8.25 5.25 8.58579 5.25 9ZM5.25 6C5.25 6.41421 5.58579 6.75 6 6.75H12C12.4142 6.75 12.75 6.41421 12.75 6C12.75 5.58579 12.4142 5.25 12 5.25H6C5.58579 5.25 5.25 5.58579 5.25 6Z"
          fill="#F9F9F9"
        />
      </g>
    </svg>
  );
}
